import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground p-4 text-center relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/[0.02] via-transparent to-transparent pointer-events-none" />

      <h1 className="text-9xl font-black text-primary/20 mb-4 select-none relative z-10">404</h1>
      <h2 className="text-4xl font-bold mb-4 font-display relative z-10">Page Not Found</h2>
      <p className="text-xl text-muted-foreground mb-8 max-w-md relative z-10">
        The page you are looking for doesn&apos;t exist or has been moved.
      </p>
      <Button asChild size="lg" className="relative z-10 transition-all duration-300">
        <Link to="/">Return Home</Link>
      </Button>
    </div>
  );
};

export default NotFound;